<template>
    <system-page :page-settings="page">
        <div class="c-content main">
            <div class="c-warningBox c-warningBox-icon u-mb-lg">
                <p>複数回のログイン試行に失敗したため、セキュリティ保護のためにこのアカウントを一時的にロックしました。</p>
                <p>ロック解除したい場合は、お問い合わせください。</p>
            </div>

            <a href="https://www.pokemon-card.com/contact/" target="_blank" class="c-btn c-btn-primary">
                お問い合わせはこちら
            </a>
        </div>
    </system-page>
</template>

<script>
import SystemPage from '@/component/SystemPage.vue'

export default {
    name: 'AccountLock',
    components: {
        SystemPage,
    },
    data() {
        return {
            page: {
                title: 'このアカウントはロックされました',
                breakedTitle: 'このアカウントは<br class="u-display-sp">ロックされました',
                desc: 'ポケモンカードゲーム プレイヤーズクラブ このアカウントはロックされましたのページ。',
                breadcrumb: [],
            },
        }
    },
    mounted() {
        document.title = this.page.title + ' | ポケモンカードゲーム プレイヤーズクラブ'
        document.querySelector("meta[name='description']").setAttribute('content', this.page.desc)
    },
}
</script>

<style lang="scss" scoped>
@use '~@/assets/style/global' as g;

.main {
    text-align: center;
    @include g.pc {
        padding-top: 65px;
        padding-bottom: 110px;
    }
    @include g.sp {
        padding-top: 18px;
        padding-bottom: 72px;
    }
}

.c-warningBox {
    position: relative;
    text-align: left;

    &::before {
        position: absolute;
        left: 32px;
    }

    & > p {
        margin-left: 21px;
        font-weight: bold;
    }
}

</style>
